var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagSudan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.58763 9.0544C0.5705 11.1579 0 13.5177 0 16.0109C0 18.5041 0.5705 20.8639 1.58763 22.9674L16 24.3587L30.4124 22.9674C31.4295 20.8639 32 18.5041 32 16.0109C32 13.5177 31.4295 11.1579 30.4124 9.0544L16 7.66309L1.58763 9.0544Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58789 22.9673C4.17577 28.3192 9.65633 32.0108 15.9997 32.0108C22.3431 32.0108 27.8236 28.3192 30.4115 22.9673H1.58789Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58789 9.05424H30.4115C27.8236 3.7023 22.3431 0.0107422 15.9997 0.0107422C9.65633 0.0107422 4.17577 3.7023 1.58789 9.05424Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68622 4.69678C-1.56215 10.9452 -1.56215 21.0758 4.68622 27.3243C7.26828 24.7422 9.75159 22.2589 16 16.0105L4.68622 4.69678Z",
    fill: "#496E2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSudan);
export default __webpack_public_path__ + "static/media/flag_sudan.443e259389877565d7b55e3c743f0fbd.svg";
export { ForwardRef as ReactComponent };